/* Unit Types */
export const ACRES = 'acres';
export const HECTARES = 'hectare';
export const SQUARE_FEET = 'sf';
export const SQUARE_METERS = 'sm';
export const FEET = 'f';
export const METERS = 'm';
export const MILES = 'miles';
export const KILOMETERS = 'km';

/* Sale Currency */
export const DOLLARS          = "dollars";
export const DOLLARS_PER_SF   = "dollars_per_sf";
export const DOLLARS_PER_SM   = "dollars_per_sm";
export const DOLLARS_PER_ACRE = "dollars_per_acre";
export const DOLLARS_PER_HECTARE = "dollars_per_hectare";

/* Lease Rate */
export const SF_PER_YEAR       = "sf_per_year";
export const SF_PER_MONTH      = "sf_per_month";
export const SM_PER_YEAR       = "sm_per_year";
export const SM_PER_MONTH      = "sm_per_month";
export const ACRE_PER_YEAR     = "acre_per_year";
export const ACRE_PER_MONTH    = "acre_per_month";
export const HECTARE_PER_YEAR  = "hectare_per_year";
export const HECTARE_PER_MONTH = "hectare_per_month";
export const PER_YEAR          = "per_year";
export const PER_MONTH         = "per_month";

export const LEASE_RATES = [
  SF_PER_YEAR,
  SF_PER_MONTH,
  SM_PER_YEAR,
  SM_PER_MONTH,
  ACRE_PER_YEAR,
  ACRE_PER_MONTH,
  HECTARE_PER_YEAR,
  HECTARE_PER_MONTH,
  PER_YEAR,
  PER_MONTH
];

export const AVAILABLE_IMPERIAL = [ACRES, SQUARE_FEET];
export const AVAILABLE_METRIC   = [HECTARES, SQUARE_METERS];

const LABEL_MAP = {};
LABEL_MAP[ACRES] = 'Acres';
LABEL_MAP[HECTARES] = 'Hectares';
LABEL_MAP[SQUARE_FEET] = 'SF';
LABEL_MAP[SQUARE_METERS] = 'm²';
LABEL_MAP[FEET] = 'ft';
LABEL_MAP[METERS] = 'm';
LABEL_MAP[MILES] = 'miles';
LABEL_MAP[KILOMETERS] = 'km';

const IMPERIAL_RATE_LABEL_MAP = {};
IMPERIAL_RATE_LABEL_MAP[SF_PER_YEAR] = `/ ${LABEL_MAP[SQUARE_FEET]} / year`;
IMPERIAL_RATE_LABEL_MAP[SF_PER_MONTH] = `/ ${LABEL_MAP[SQUARE_FEET]} / month`;
IMPERIAL_RATE_LABEL_MAP[ACRE_PER_YEAR] = `/ ${LABEL_MAP[ACRES]} / year`;
IMPERIAL_RATE_LABEL_MAP[ACRE_PER_MONTH] = `/ ${LABEL_MAP[ACRES]} / month`;
IMPERIAL_RATE_LABEL_MAP[PER_YEAR] = `/ year`;
IMPERIAL_RATE_LABEL_MAP[PER_MONTH] = `/ month`;

const METRIC_RATE_LABEL_MAP = {};
METRIC_RATE_LABEL_MAP[SM_PER_MONTH] = '/ #{LABEL_MAP[SQUARE_METERS]} / month';
METRIC_RATE_LABEL_MAP[SM_PER_YEAR] = '/ #{LABEL_MAP[SQUARE_METERS]} / year';
METRIC_RATE_LABEL_MAP[HECTARE_PER_MONTH] = '/ #{LABEL_MAP[HECTARES]} / month';
METRIC_RATE_LABEL_MAP[HECTARE_PER_YEAR] = '/ #{LABEL_MAP[HECTARES]} / year';
METRIC_RATE_LABEL_MAP[PER_YEAR] = '/ year';
METRIC_RATE_LABEL_MAP[PER_MONTH] = '/ month';

const CONVERSION_MAP = {};
CONVERSION_MAP[ACRES] = 43560.0;
CONVERSION_MAP[HECTARES] = 107639.0;
CONVERSION_MAP[SQUARE_FEET] = 1.0;
CONVERSION_MAP[SQUARE_METERS] = 10.7639;
CONVERSION_MAP[FEET] = 1.0;
CONVERSION_MAP[METERS] = 3.28084;
CONVERSION_MAP[MILES] = 5280.0;
CONVERSION_MAP[KILOMETERS] = 3280.84;

/* [label, time conversion, area conversion] */
const RATE_CONVERSION_MAP = {};
RATE_CONVERSION_MAP[SF_PER_MONTH] = [1.0, SQUARE_FEET];
RATE_CONVERSION_MAP[SM_PER_MONTH] = [1.0, SQUARE_METERS];
RATE_CONVERSION_MAP[ACRE_PER_MONTH] = [1.0, ACRES];
RATE_CONVERSION_MAP[HECTARE_PER_MONTH] = [1.0, HECTARES];
RATE_CONVERSION_MAP[PER_MONTH] = [1.0, null];
RATE_CONVERSION_MAP[SF_PER_YEAR] = [12.0, SQUARE_FEET];
RATE_CONVERSION_MAP[SM_PER_YEAR] = [12.0, SQUARE_METERS];
RATE_CONVERSION_MAP[ACRE_PER_YEAR] = [12.0, ACRES];
RATE_CONVERSION_MAP[HECTARE_PER_YEAR] = [12.0, HECTARES];
RATE_CONVERSION_MAP[PER_YEAR] = [12.0, null];

export const RATE_LABEL_MAP = { ...IMPERIAL_RATE_LABEL_MAP, ...METRIC_RATE_LABEL_MAP };
export {
  CONVERSION_MAP,
  IMPERIAL_RATE_LABEL_MAP,
  LABEL_MAP,
  METRIC_RATE_LABEL_MAP,
  RATE_CONVERSION_MAP
};
